import React, { useEffect, useCallback, useState, useRef } from 'react';
import { Box, Fab } from '@material-ui/core';
import { useDispatch } from 'dva';
import { history, useLocation } from 'umi';
import AddIcon from '@material-ui/icons/Add';
import qs from 'qs';
import dayjs from 'dayjs';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import ErrorIcon from '@material-ui/icons/Error';
import Search from './components/Search';
import Tables from './components/Tables';
import DialogDataML from '@/components/DialogDataML/DialogDataML';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query, pathname } = location;
  const {
    appId = '',
    pageNum = '1',
    pageSize = '10',
    name = '',
    time,
    miniQrCodeGroupName = '',
  } = query;
  const [groupDeleteOpen, setGroupDeleteOpen] = useState(false);
  const [chooseRowData, setChooseRowData] = useState(null);
  //监听批量导入的状态
  const [stopQrCodeOpen, setStopQrCodeOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const searchRef = useRef();
  // 条件记忆路由统一处理
  const keepParams = ({ isSearchStatus, ...newParams }) => {
    // const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    if (isSearchStatus) {
      setIsSearch(true);
    }
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParams,
      })}`,
    );
  };
  const fetchTablesList = useCallback(() => {
    if (!appId) {
      return;
    }
    const type = 'miniQrCode/getQueryQrCodeGroupPage';
    const values = {
      appId,
      pageNum,
      pageSize,
      groupName: name,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type,
      payload: {
        values,
      },
      callback: () => {
        const newParams = {
          ...query,
        };
        keepParams(newParams);
      },
    });
  }, [dispatch, appId, pageNum, pageSize, name, time, miniQrCodeGroupName]);
  useEffect(() => {
    fetchTablesList();
  }, [fetchTablesList]);
  // 点击新建按钮
  const handleClickAdd = () => {
    history.push({
      pathname: '/miniapps/qr_code/qr_code_add',
      query: {
        queryType: 'add',
      },
    });
  };

  //删除群组
  const handleClickDeleteGroup = (row) => {
    setGroupDeleteOpen(true);
    setChooseRowData(row);
  };

  //删除群组 取消按钮
  const onCloseGroupDeleteDialog = () => {
    setGroupDeleteOpen(false);
    setChooseRowData();
  };
  //删除群组/小程序码共同方法 保存按钮
  const onCloseGroupSaveDialog = () => {
    const type = 'miniQrCode/deleteQrCodeGroup';
    const values = { id: chooseRowData.id };
    dispatch({
      type,
      payload: {
        values,
      },
      callback: (code) => {
        if (code === 0) {
          setGroupDeleteOpen(false);
          setChooseRowData();
          fetchTablesList();
        }
      },
    });
  };
  //编辑小程序码分组和小程序码共同方法
  const handleEditClick = (row) => {
    history.push({
      pathname: '/miniapps/qr_code/qr_code_edit',
      query: {
        queryType: 'edit',
        id: String(row.id),
      },
    });
  };

  //终止小程序码
  const handleStopTask = (row) => {
    setChooseRowData(row);
    setStopQrCodeOpen(true);
  };

  //点击停用的取消按钮
  const onCloseStopQrCodeDialog = () => {
    setChooseRowData();
    setStopQrCodeOpen(false);
  };
  //点击确认停用小程序码
  const onConfirmStopQrCodeDialog = () => {
    dispatch({
      type: 'miniQrCode/stopQrCode',
      payload: {
        values: {
          id: chooseRowData.id,
        },
      },
      callback: (code) => {
        if (code === 0) {
          const thisTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
          const newParams = {
            ...query,
            time: thisTime,
          };
          keepParams(newParams);
          setChooseRowData();
          setStopQrCodeOpen(false);
        }
      },
    });
  };
  //点击下载
  const handleDownLoadClick = (row) => {
    dispatch({
      type: 'miniQrCode/downQrcodeZip',
      payload: {
        values: {
          id: row.id,
          envVersion: process.env.QRCODE_ENV_VERSION,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          setAlertOpen(true);
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
        }
      },
    });
  };

  const handleClose = () => {
    setAlertOpen(false);
  };
  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_miniprogram_qrcode_management_list',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <Search keepParams={keepParams} searchRef={searchRef} />
      <Box
        className="button-wrap"
        style={{ margin: '24px 0', paddingLeft: '32px' }}
      >
        <Fab
          data-log={JSON.stringify({
            oid: 'btn_miniprogram_qrcode_management_list_add',
            events: ['_ev', '_ec'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
          })}
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          sx={{ marginRight: '16px' }}
          onClick={handleClickAdd}
        >
          <AddIcon sx={{ width: '24px', height: '24px' }} />
          新建小程序码
        </Fab>
      </Box>
      <Tables
        keepParams={keepParams}
        onClickDeleteGroup={handleClickDeleteGroup}
        handleEditClick={handleEditClick}
        handleStopTask={handleStopTask}
        handleDownLoadClick={handleDownLoadClick}
      />
      <DialogDataML
        open={groupDeleteOpen}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            删除
          </Box>
        }
        content="删除后分组下的小程序码将会被清空，确定要删除该分组吗？"
        handleClose={onCloseGroupDeleteDialog}
        handleConfirm={onCloseGroupSaveDialog}
      />
      <DialogDataML
        open={stopQrCodeOpen}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            停用
          </Box>
        }
        content="确定要停用这个小程序码吗？"
        handleClose={onCloseStopQrCodeDialog}
        handleConfirm={onConfirmStopQrCodeDialog}
      />
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          数据包导出中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </Box>
  );
};
